import { call, put, all, takeEvery } from 'redux-saga/effects';
import { conversationActions, authActions } from 'store/actions';
import { createRoom as roomCreate, updateRoomStatus, syncRoomsFromApiToFirebase, deleteRoom, apiRoomToFirebasePayload } from 'store/services/firebase-broadcast';
import ACTIONS from 'store/constants';
import ApiResponse from 'modules/response/response.types';
import {
  ICreateRoomParams,
  INearByRoomsParams, IRoomStatusParams,
  IURLIdParams,
} from 'modules/params/param.type';
import api from 'store/services/conversation.service';
import moment from 'moment';

function* createRoom(state: { type: string; payload: ICreateRoomParams }) {
  try {
    yield put(conversationActions.createRoom.pending);
    const response: ApiResponse = yield call(api.createRoomRequest, state.payload);
    if (response) {
      // const data = JSON.stringify(response.data);
      // const user = JSON.parse(localStorage.getItem('user') || '');
      // const payload = {
      //   profile_id: user.pk.toString(),
      //   room_id: JSON.parse(data).pk.toString(),
      // };
      // yield put(authActions.createPublicProfileRequest(payload));
      const room: any = response.data;
      const obj = {
        ...apiRoomToFirebasePayload(room),
        timeStamp: 'new Date()',
        created_at: moment().format(),
        intro_video_url: state.payload.intro_video_url || room.intro_video_url || null,
      };
      
      yield call(roomCreate, obj);
      yield put(conversationActions.createRoom.success(response));
    }
  } catch (error: any) {
    yield put(conversationActions.createRoom.error(error.message));
  }
}

function* getAllRooms() {
  try {
    yield put(conversationActions.fetchAllRooms.pending);
    const response: ApiResponse = yield call(api.getAllRoomsRequest);
    if (response) {
      yield put(conversationActions.fetchAllRooms.success(response));
    }
  } catch (error: any) {
    yield put(conversationActions.fetchAllRooms.error(error.message));
  }
}

function* getRoom() {
  try {
    yield put(conversationActions.fetchRoom.pending);
    const response: ApiResponse = yield call(api.getRoomRequest);
    if (response) {
      yield put(conversationActions.fetchRoom.success(response));
    }
  } catch (error: any) {
    yield put(conversationActions.fetchRoom.error(error.message));
  }
}

function* joinRoom(state: { type: string; payload: IURLIdParams }) {
  try {
    yield put(conversationActions.joinRoom.pending);
    const response: ApiResponse = yield call(api.joinRoomRequest, state.payload);
    if (response) {
      yield put(conversationActions.joinRoom.success(response));
    }
  } catch (error: any) {
    yield put(conversationActions.joinRoom.error(error.message));
  }
}

function* nearByRoom(state: { type: string; payload: INearByRoomsParams }) {
  try {
    yield put(conversationActions.nearbyRooms.pending);
    const response: ApiResponse = yield call(api.nearByRoomsRequest, state.payload);
    if (response) {
      // Render the API rooms first — this must not depend on Firebase. Otherwise
      // a Firebase outage (e.g. RTDB "Client is offline") would throw below and
      // the rooms would never reach the store, showing "No conversations nearby"
      // even though the API returned them.
      yield put(conversationActions.nearbyRooms.success(response));

      const rooms = Array.isArray(response) ? response : (response as any).data;
      if (Array.isArray(rooms)) {
        try {
          yield call(syncRoomsFromApiToFirebase, rooms);
        } catch (syncError: any) {
          // Best-effort mirror to Firebase; never let it hide the room list.
          console.error('Failed to sync nearby rooms to Firebase:', syncError);
        }
      }
    }
  } catch (error: any) {
    yield put(conversationActions.nearbyRooms.error(error.message));
  }
}

function* roomStatus(state: { type: string; payload: IRoomStatusParams }) {
  try {
    yield put(conversationActions.roomStatus.pending);
    const response: ApiResponse = yield call(api.roomStatusRequest, state.payload);
    if (response && state.payload.id) {
      const firebasePayload: { id: number | string; status: string; call_active?: boolean } = {
        id: state.payload.id,
        status: state.payload.status,
      };
      if (state.payload.status === 'VIDEO') {
        firebasePayload.call_active = false;
      }
      yield call(updateRoomStatus, firebasePayload);
      yield put(conversationActions.roomStatus.success(response));
    }
  } catch (error: any) {
    yield put(conversationActions.roomStatus.error(error.message));
  }
}

function* roomDelete(state: { type: string; payload: { id: string } }) {
  try {
    yield put(conversationActions.roomDelete.pending);
    const response: ApiResponse = yield call(api.roomDeleteRequest, state.payload);
    if (response) {
      yield call(deleteRoom, { roomId: state.payload.id });
      yield put(conversationActions.roomDelete.success(response));
    }
  } catch (error: any) {
    yield put(conversationActions.roomDelete.error(error.message));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.CREATE_ROOM_BEGIN, createRoom),
    takeEvery(ACTIONS.NEARBY_ROOMS_BEGIN, nearByRoom),
    takeEvery(ACTIONS.ROOM_LIST_BEGIN, getAllRooms),
    takeEvery(ACTIONS.CREATE_ROOM_FETCH_BEGIN, getRoom),
    takeEvery(ACTIONS.JOIN_ROOM_BEGIN, joinRoom),
    takeEvery(ACTIONS.ROOM_STATUS_BEGIN, roomStatus),
    takeEvery(ACTIONS.ROOM_DELETE_BEGIN, roomDelete),
  ]);
}
